module.exports = __webpack_public_path__ + "img/reg.45a9f0a6.svg";